import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@strava/ui/Avatar';
import Stats from '@strava/ui/Stats';
import Stat from '@strava/ui/Stat';
import I18n from 'utils/I18n';
import { useActivityPublicContext } from '../../ActivityPublicContext';
import CTA from '../CTA';

import styles from './styles.scss';

const AthleteBanner = ({
  name,
  firstName,
  avatarUrl,
  location,
  followersCount,
  followAthleteUrl,
  totalDistance,
  totalActivities,
  unitSystem
}) => {
  const { openSignUpModal, track } = useActivityPublicContext();

  const trackClick = useCallback(
    (element) => {
      track({
        element,
        action: 'click'
      });
    },
    [track]
  );

  return (
    <div className={styles.bannerWrapper}>
      <div className={`container ${styles.bannerContainer}`}>
        <div className={styles.avatarWrapper}>
          <Avatar
            name={name}
            src={avatarUrl}
            type="athlete"
            className={styles.avatar}
            data-cy="athlete-banner-avatar"
            onClick={() => {
              trackClick('profile_picture');
              openSignUpModal('generic');
            }}
          />
        </div>
        <div className={styles.detailsWrapper}>
          <h3 className={styles.name}>{name}</h3>
          <span className={styles.location}>{location}</span>
        </div>
        <div className={styles.followButtonWrapper}>
          <CTA
            href={followAthleteUrl}
            data-cy="follow-athlete-cta"
            modalVariant="follow_athlete"
            onClick={() => trackClick('follow_on_strava')}
          >
            {I18n.t('strava.activities.show_public.follow_on_strava_v2', {
              firstName
            })}
          </CTA>
        </div>
        <Stats listClassName={styles.bannerStats}>
          <Stat
            label={I18n.t('strava.activities.show_public.followers')}
            value={followersCount}
            labelClassName={styles.statLabel}
            type="stat-xl"
          />
          {totalDistance && (
            <Stat
              label={I18n.t(
                `strava.activities.show_public.ytd_${
                  unitSystem === 'imperial' ? 'miles' : 'km'
                }`,
                { year: new Date().getFullYear() }
              )}
              value={totalDistance}
              type="stat-xl"
              labelClassName={styles.statLabel}
            />
          )}
          {totalActivities ? (
            <Stat
              label={I18n.t(
                'strava.activities.show_public.year_stats_activities',
                { year: new Date().getFullYear() }
              )}
              value={totalActivities}
              type="stat-xl"
              labelClassName={styles.statLabel}
            />
          ) : null}
        </Stats>
      </div>
    </div>
  );
};

AthleteBanner.defaultProps = {
  totalDistance: null,
  totalActivities: null
};

AthleteBanner.propTypes = {
  name: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string.isRequired,
  followersCount: PropTypes.number.isRequired,
  followAthleteUrl: PropTypes.string.isRequired,
  unitSystem: PropTypes.string.isRequired,
  totalDistance: PropTypes.string,
  totalActivities: PropTypes.number
};

export default AthleteBanner;
